import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import storage from "redux-persist/lib/storage";
import { siteReducer, uiErrorReducer } from "sc/reducers/ui-reducers";
import userReducer from "./user-reducer";
import editedUserReducer from "./edited-user-reducer";
import impersonatedPartnerReducer from "./impersonated-partner-reducer";
import uiPartnersReducer from "./ui-partners-reducer";
import partnersReducer from "./partners-reducer";
import partnerReducer from "./partner-reducer";
import regionsReducer from "./regions-reducer";
import regionReducer from "./region-reducer";
import citiesReducer from "./cities-reducer";
import cityReducer from "./city-reducer";
import engineersReducer from "./engineers-reducer";
import listUsersReducer from "./list-users-reducer";
import globalSettingsReducer from "./global-settings-reducer";
import scheduleStatusReducer from "./schedule-status-reducer";
import engineerReducer from "./engineer-reducer";
import engineerSearchResultsReducer from "./engineer-search-results-reducer";
import shiftsDefinitionsReducer from "./shifts-definitions-reducer";
import { createUnstableFeaturesStatusReducer } from "../../../../reducers/unstable-features-status";

export const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "unstableFeaturesStatus",
    "user",
    "partners",
    "impersonatedPartner",
    "logo",
  ],
};

export const createAppReducer = () => {
  return combineReducers({
    unstableFeaturesStatus: createUnstableFeaturesStatusReducer(),
    ui: combineReducers({
      router: routerReducer,
      site: siteReducer,
      error: uiErrorReducer,
    }),
    user: userReducer,
    impersonatedPartner: impersonatedPartnerReducer,
    partners: partnersReducer,
    uiPartners: uiPartnersReducer,
    partner: partnerReducer,
    regions: regionsReducer,
    region: regionReducer,
    cities: citiesReducer,
    city: cityReducer,
    engineers: engineersReducer,
    engineer: engineerReducer,
    users: listUsersReducer,
    editedUser: editedUserReducer,
    globalSettings: globalSettingsReducer,
    scheduleStatus: scheduleStatusReducer,
    engineerSearchResults: engineerSearchResultsReducer,
    shiftsDefinitions: shiftsDefinitionsReducer,
  });
};



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/app-reducer.js